//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import _ from 'lodash'
import draggable from 'vuedraggable'
import { axiosGet, axiosPost } from '../../axios/axios.js'
import { EventBus } from '../../EventBus/EventBus.js'
import { getFilterIcon } from './ServerFilterIcons.js'
import { formatFiltersForServer, formatFiltersFromServer, formatFiltersToArray, validateFilters } from './ServerFilterUtils.js'

import DateIntervalField from '../Field/DateIntervalField.vue'
import DateField from '../Field/DateField.vue'
import ServerFilterDeleteProfilesDialog from './ServerFilterDeleteProfilesDialog.vue'
import ServerFilterSaveProfileDialog from './ServerFilterSaveProfileDialog.vue'
import ServerFilterListOptionSlot from './ServerFilterListOptionSlot.vue'
import ServerFilterListTable from './ServerFilterListTable.vue'
import ServerFilterPrependSlot from './ServerFilterPrependSlot.vue'
import ServerFilterModeValueBadge from './ServerFilterModeValueBadge.vue'

function arrayMove (array, oldIndex, newIndex) {
  while (oldIndex < 0) {
    oldIndex += array.length
  }
  while (newIndex < 0) {
    newIndex += array.length
  }

  if (newIndex >= array.length) {
    let k = newIndex - array.length + 1
    while (k--) {
      array.push(undefined)
    }
  }

  array.splice(newIndex, 0, array.splice(oldIndex, 1)[0])
}

export default {
  components: {
    DateIntervalField,
    ServerFilterDeleteProfilesDialog,
    ServerFilterSaveProfileDialog,
    ServerFilterListOptionSlot,
    ServerFilterListTable,
    ServerFilterPrependSlot,
    ServerFilterModeValueBadge,
    DateField,
    draggable
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    formId: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    closable: {
      type: Boolean,
      default: false
    },
    simple: {
      type: Boolean,
      default: false
    },
    unavailibale: {
      type: Boolean,
      default: false
    },
    /***
     * Значения фильтров по умолчанию, которые будут установлены после загрузки параметров фильтрации
     * <ключ фильтра>: <значение фильтра>
     * Будет подставлено в value для соответствующего ключу фильтра
     * (требуется для фильтра Журнала контроля, где фильтру stockId необходимо
     * задать значение, равное ИД склада, для которого открыт журнал)
     */
    defaultValues: {
      type: Object,
      default: function () {
        return null
      }
    }
  },
  data: function () {
    return {
      editMode: false,
      loading: false,
      filters: {},
      filtersArray: [],
      filterProfiles: [],
      setFilterPolygon: null,
      polygonDrawMode: false,
      polygonShowMode: false,
      globalFilterProfileChangeAccess: false,
      saveFilterDialogOpened: false,
      profilePopup: false,
      deleteFilterProfilesDialogOpened: false,
      currentFilterProfiles: [],
      updateServerFilterHandler: null,
      selectedFilterIndex: null,
      escPressed: false,
      dragEscaped: false,
      filtersOptions: [],
      filterSearchValue: null,

      getFilterIcon: getFilterIcon
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    editModeMainCheckbox: {
      get: function () {
        let activeCount = 0
        let activeAlwaysCount = 0
        for (const filter of this.filtersArray) {
          if (filter.activeCustom) {
            activeCount++
            if (filter.activeAlways) {
              activeAlwaysCount++
            }
          }
        }

        if (this.filtersArray.length === activeCount) {
          return true
        } else if (activeCount - activeAlwaysCount === 0) {
          return false
        }
        return null
      },
      set: function (value) {
        for (const filter of this.filtersArray) {
          if (!filter.activeAlways) {
            filter.activeCustom = !!value
          }
        }
      }
    },
    shownFilters: function () {
      const activeFull = this.filters.activeFull
      return this.filtersArray.filter(filter => {
        return !filter.hidden && (activeFull || filter.active) && filter.name.toLowerCase().includes(this.filterSearchValue && this.filterSearchValue.toLowerCase() || '')
      })
    }
  },
  watch: {
    user: {
      handler: function (user) {
        if (user && user.systemUser && user.hasOperation('manageGlobalFilter')) {
          this.globalFilterProfileChangeAccess = true
        }
      },
      immediate: true
    },
    type: function () {
      if (this.polygonDrawMode) {
        this.onSwitchPolygonDrawMode()
      }
      if (this.polygonShowMode) {
        this.onSwitchPolygonShowMode()
      }
      if (!this.unavailibale) {
        this.getFilter()
        this.loadFilterProfiles()
        this.editMode = false
      }
    },
    formId: function () {
      this.polygonShowMode = false
      EventBus.$emit('switch-show-mode-polygon', false)
      if (!this.unavailibale) {
        this.getFilter()
        this.loadFilterProfiles()
        this.editMode = false
      }
    },
    editMode: function (result) {
      if (!result) {
        this.selectedFilterIndex = null
        this.loadFilter()
      }
    },
    // polygonDrawMode: function (result) {
    //   if (result === true) {
    //     if (this.polygonShowMode) {
    //       this.polygonShowMode = false
    //       EventBus.$emit('switch-show-mode-polygon', false)
    //     }
    //   }
    // },
    // polygonShowMode: function (result) {
    //   if (result === true) {
    //     if (this.polygonDrawMode) {
    //       this.polygonDrawMode = false
    //       EventBus.$emit('switch-draw-mode-polygon', false)
    //     }
    //   }
    // },
    'filters.profile': {
      handler: function () {
        // В таблице узнать текущий выбранный профиль фильтрации
        EventBus.$emit('update-' + this.type + '-profile', this.filters.profile)
      },
      immediate: true
    }
  },
  created: function () {
    this.updateServerFilterHandler = (event) => {
      if (!this.unavailibale && (!event || !event.type || event.type === this.type)) {
        this.getFilter()
        this.loadFilterProfiles()
      }
    }

    EventBus.$on('update-server-filter', this.updateServerFilterHandler)
    EventBus.$on('draw-polygon-started', this.applyFilterWithoutGeoZone)
    EventBus.$on('show-geozones-strokes', this.onShowGeozonesStrokes)

    if (!this.unavailibale) {
      this.getFilter()
      this.loadFilterProfiles()
    }

    this.setFilterPolygon = (coords, index = null) => {
      for (const prop in this.filters) {
        const filter = this.filters[prop]
        if (filter && filter.type && filter.type === 'polygon') {
          if (index !== null) {
            filter.coords.splice(index, 1, coords)
          } else if (coords[0] instanceof Array) {
            filter.coords = coords
          } else if (filter.coords && filter.coords.length) {
            filter.coords.push(coords)
          } else {
            filter.coords = [coords]
          }
          this.redrawPolygon(filter)
        }
      }

      // this.polygonDrawMode = false
      // this.onApplyFilter()
    }

    EventBus.$on('polygon-selected', this.setFilterPolygon)
    EventBus.$on('polygon-updated', this.setFilterPolygon)
    this.setGlobalListeners()
  },
  beforeDestroy: function () {
    EventBus.$off('polygon-selected', this.setFilterPolygon)
    EventBus.$off('polygon-updated', this.setFilterPolygon)
    EventBus.$off('update-server-filter', this.updateServerFilterHandler)
    EventBus.$off('draw-polygon-started', this.applyFilterWithoutGeoZone)
    EventBus.$off('show-geozones-strokes', this.onShowGeozonesStrokes)
    this.removeGlobalListeners()
  },
  methods: {
    setGlobalListeners: function () {
      document.addEventListener('keydown', this.escDownListener)
      document.addEventListener('keyup', this.escUpListener)
    },
    removeGlobalListeners: function () {
      document.removeEventListener('keydown', this.escDownListener)
      document.removeEventListener('keyup', this.escUpListener)
    },
    onEnter: function (event) {
      event.stopPropagation()
      this.onApplyFilter()
    },
    onAltS: function (event) {
      event.stopPropagation()
      this.onSaveFilter()
    },
    onShiftDelete: function (event) {
      event.stopPropagation()
      this.onResetFilter()
    },
    onCtrlDelete: function (event) {
      event.stopPropagation()
      this.onClearFilter(true)
    },
    onAltDelete: function (event) {
      event.stopPropagation()
      this.onDeleteFilterProfiles()
    },
    onSaveFilterSettings: function () {
      this.editMode = false
      this.formatFilterForSaveFilterSettings()
      this.onApplyFilter(() => {
        this.editMode = false
        this.emitUpdateDataEvent()
        this.getFilter()
      })
    },
    formatFilterForSaveFilterSettings: function () {
      for (const filter of Object.values(this.filters)) {
        if (typeof filter === 'object' && filter !== null) {
          filter.active = filter.activeCustom
        }
      }
    },
    isIndicator: function (profileName) {
      if (this.type !== 'alarm' || !profileName) {
        return false
      }

      const profile = this.filterProfiles.find(profile => profile.name === profileName)
      return profile && profile.alarmIndicator
    },
    onShowFullFilter: function () {
      this.filters.activeFull = true
      this.onApplyFilter()
    },
    onShowGeozonesStrokes: function () {
      EventBus.$emit('switch-show-strokes', this.filters.polygon)
    },
    onShowUserFilter: function () {
      this.filters.activeFull = false
      this.onApplyFilter()
    },
    onApplyFilterProfile: function (profileName) {
      this.loading = true
      const url = '/service/delta/dispatcher/setcurrentfilterprofile?' +
          this.getFilterUrlParameters() +
          '&name=' + encodeURI(profileName)

      axiosGet({
        url: url,
        onSuccess: () => {
          this.emitUpdateDataEvent()
          this.loadFilter()
          this.loadFilterProfiles()
        },
        onFailure: 'Ошибка применения профиля фильтрации',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    loadFilterProfiles: function () {
      this.loading = true
      axiosGet({
        url: '/service/delta/dispatcher/getfilterprofiles?' + this.getFilterUrlParameters(),
        onSuccess: (response) => {
          this.filterProfiles = response.data
        },
        onFailure: 'Ошибка получения профилей фильтрации',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    getFilterUrlParameters: function (additionalParameters) {
      const params = new URLSearchParams()
      params.append('type', this.type)

      if (this.formId) {
        params.append('formId', this.formId)
      }
      if (additionalParameters) {
        Object.entries(additionalParameters).forEach(entry => {
          params.append(entry[0], entry[1])
        })
      }
      return params.toString()
    },
    emitUpdateDataEvent: function () {
      EventBus.$emit('update-' + this.type, { filterChanged: true })
      this.$emit('update')
    },
    getFilter: function () {
      this.loadFilter(null, 'getfilter', null)
    },
    loadFilter: function (
      onLoadCallback,
      urlPathParameter = 'getfilter',
      onErrorMessage = 'Ошибка загрузки фильтра',
      additionalParameters
    ) {
      this.loading = true

      axiosGet({
        url: '/service/delta/dispatcher/' + urlPathParameter + '?' + this.getFilterUrlParameters(additionalParameters),
        onSuccess: (response) => {
          this.filters = formatFiltersFromServer(response.data, this.type, this.formId)
          // Установка значений фильтров из defaultValues (!= значения по умолчанию на сервере)
          if (this.defaultValues) {
            for (const key in this.defaultValues) {
              if (this.filters[key]) {
                this.filters[key].value = this.defaultValues[key]
              }
            }
          }
          this.filtersArray = formatFiltersToArray(this.filters)
          this.filtersOptions = JSON.parse(JSON.stringify(this.filtersArray.filter(el => el.type == 'list'))) // Deep Copy
          this.modeSelectLastValue = null
          this.selectLastValue = null

          if (onLoadCallback) {
            onLoadCallback(response.data)
          }
        },
        onFailure: onErrorMessage,
        msgTarget: this
      }).finally(() => {
        this.polygonShowMode = false
        EventBus.$emit('switch-show-mode-polygon', false)
        if (this.filters.polygon) {
          EventBus.$emit('change-polygon-contain-mode', this.filters.polygon.contains)
        }
        this.loading = false
      })
    },
    onApplyFilterDirectly: function () {
      return this.onApplyFilter(() => {
        this.emitUpdateDataEvent()
        if (this.closable) {
          this.$emit('close')
        }
      })
    },
    onSetOnChange: function (filter) {

    },
    applyFilterWithoutGeoZone: function () {
      if (this.filters.polygon && this.filters.polygon.coords) {
        const coords = this.filters.polygon.coords
        this.filters.polygon.coords = null
        return this.onApplyFilterDirectly().then(result => {
          this.filters.polygon.coords = coords
        })
      }
      return Promise.resolve('noUpdate')
    },
    onApplyFilter: async function (
      onLoadCallback,
      urlPathParameter = 'setfilter',
      parameters,
      onErrorMessage = 'Ошибка применения фильтра')
    // eslint-disable-next-line brace-style
    {
      return validateFilters(this.shownFilters)
        .then(() => {
          this.loading = true

          const bodyFormData = new FormData()
          const formattedFiltersForServer = formatFiltersForServer(JSON.parse(JSON.stringify(this.filters)))
          bodyFormData.set('data', JSON.stringify(formattedFiltersForServer))

          if (parameters) {
            for (const key in parameters) {
              bodyFormData.set(key, parameters[key])
            }
          }

          return axiosPost({
            url: '/service/delta/dispatcher/' + urlPathParameter + '?' + this.getFilterUrlParameters(),
            data: bodyFormData,
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
            onSuccess: (response) => {
              this.filters.profile = response.data.result
              if (onLoadCallback) {
                onLoadCallback(response.data)
              } else {
                if (this.polygonDrawMode) {
                  this.onSwitchPolygonDrawMode()
                }
                this.emitUpdateDataEvent()
              }
            },
            onFailure: onErrorMessage,
            msgTarget: this
          }).finally(() => {
            this.loading = false
          })
        })
        .catch(message => {
          this.$q.notify({
            type: 'negative',
            message: message,
            progress: true,
            timeout: 10000
          })
        })
    },
    onResetFilter: function (apply = false) {
      this.loadFilter(
        () => {
          if (apply) {
            this.emitUpdateDataEvent()
          }
          EventBus.$emit('switch-show-mode-polygon', false)
          EventBus.$emit('switch-draw-mode-polygon', false)
          this.polygonShowMode = false
          this.polygonDrawMode = false
          EventBus.$emit('change-polygon-contain-mode', true)
        },
        'resetfilter',
        'Произошла ошибка при сбросе фильтра до настроек по умолчанию',
        { apply: apply }
      )
    },
    onClearFilter: function (apply = false) {
      this.loadFilter(
        () => {
          if (apply) {
            this.emitUpdateDataEvent()
          }
          EventBus.$emit('switch-show-mode-polygon', false)
          EventBus.$emit('switch-draw-mode-polygon', false)
          this.polygonShowMode = false
          this.polygonDrawMode = false
          EventBus.$emit('change-polygon-contain-mode', true)
        },
        'clearfilter',
        'Произошла ошибка при очистке полей фильтра',
        { apply: apply }
      )
    },
    onInputFilter: async function (filter) {
      if (filter.updateOnChange) {
        await this.updateFilter(filter.updateOnChange, filter.key)
      }
      if (filter.setOnChange) {
        await this.onApplyFilter(() => {
          // без обновления списка
        })
      }
    },
    updateFilter: function (update, field) {
      if (update) {
        return this.onApplyFilter(
          (filters) => {
            this.filters = formatFiltersFromServer(filters, this.type, this.formId)
            this.filtersArray = formatFiltersToArray(this.filters)
          },
          'updatefilter',
          { field: field },
          'Произошла ошибка при обновлении полей фильтра'
        )
      }
    },
    onClickPolygon: function (filter, event) {
      if (filter.disabled) {
        return
      }
      this.onSwitchPolygonShowMode(filter)
      this.onSwitchPolygonDrawMode()
    },
    onSwitchPolygonDrawMode: function () {
      if (!this.polygonDrawMode) {
        this.applyFilterWithoutGeoZone().then(result => {
          this.polygonDrawMode = true
          EventBus.$emit('switch-draw-mode-polygon', true)
        })
        if (!this.polygonShowMode) {
          this.onSwitchPolygonShowMode(this.filters.polygon)
        }
      } else {
        this.polygonDrawMode = false
        EventBus.$emit('switch-draw-mode-polygon', false)
      }
    },
    onSwitchPolygonShowMode: function (filter) {
      if (!this.polygonShowMode) {
        this.polygonShowMode = true
        EventBus.$emit('switch-show-mode-polygon', true, filter)
      } else {
        this.polygonShowMode = false
        EventBus.$emit('switch-show-mode-polygon', false, filter)
        this.onApplyFilterDirectly()
      }
    },
    redrawPolygon: function (filter) {
      EventBus.$emit('switch-show-mode-polygon', this.polygonShowMode, filter)
    },
    onRemovePolygon: function (filter, id) {
      filter.coords.splice(id, 1)
      if (!filter.coords.length) {
        this.polygonShowMode = false
        EventBus.$emit('switch-show-mode-polygon', false)
        this.polygonDrawMode = false
        EventBus.$emit('switch-draw-mode-polygon', false)
      } else {
        EventBus.$emit('switch-show-mode-polygon', true, filter)
      }
      EventBus.$emit('switch-show-strokes', filter)
    },
    onChangeListFilterMode: function (filter, index) {
      // if (filter.multivalue) {
      //   if (filter.selectedMode) {
      //     switch (filter.selectedMode) {
      //       case 'containsAll':
      //         filter.containsAll = true
      //         filter.inverted = false
      //         break
      //       case 'containsAny':
      //         filter.containsAll = false
      //         filter.inverted = false
      //         break
      //       case 'notContainsAll':
      //         filter.containsAll = true
      //         filter.inverted = true
      //         break
      //       case 'notContains':
      //         filter.containsAll = false
      //         filter.inverted = true
      //         break
      //     }
      //   }
      // } else {
      //   filter.inverted = filter.selectedMode !== null && filter.selectedMode === 'notContains'
      // }
      this.updateFilter(filter.updateOnChange, index)
    },
    onChangeListFilterArchiveOpt: function (filter, index) {
      this.updateFilter(true, index)
    },
    onChangeLastRangePicker: _.debounce(function (filter) {
      if (typeof filter.value === 'string' && filter.value.length === 0) {
        filter.value = null
      }
      this.updateFilter(filter.updateOnChange, filter.key)
    }, 1000),
    onChangePolygonContainMode: function (event) {
      EventBus.$emit('change-polygon-contain-mode', event)
    },
    onClickDateFilter: function (filter) {
      const picker = this.$refs[filter.key + '_date_picker']
      if (picker && picker.length) {
        picker[0].show()
      }
    },
    onClearDateFilter: function (filter) {
      filter.values = null
      this.updateFilter(filter.updateOnChange, filter.key)
    },
    onUpdateDateFilter: function (filter) {
      this.updateFilter(filter.updateOnChange, filter.key)
      const picker = this.$refs[filter.key + '_date_picker']
      if (picker && picker.length) {
        picker[0].hide()
      }
    },
    onChangeDateRangePicker: function (value, filter) {
      filter.convertedRange = value
      filter.from = value.start
      filter.to = value.end

      if (value.start && value.end) {
        filter.values = null
        filter.convertedValue = null
      }

      this.updateFilter(filter.updateOnChange, filter.key)
    },
    onDeleteFilterProfiles: function () {
      this.currentFilterProfiles = this.filterProfiles
      this.deleteFilterProfilesDialogOpened = true
    },
    onDeleteFilterProfilesDialogConfirm: function (currentFilterProfiles) {
      this.filterProfiles = currentFilterProfiles
      this.deleteFilterProfilesDialogOpened = false
      this.emitUpdateDataEvent()
      this.loadFilter()
    },
    onDeleteFilterProfilesDialogClose: function () {
      this.deleteFilterProfilesDialogOpened = false
    },
    onSaveFilter: function () {
      validateFilters(this.shownFilters)
        .then(() => {
          this.saveFilterDialogOpened = true
        })
        .catch(message => {
          this.$q.notify({
            type: 'negative',
            message: message,
            progress: true,
            timeout: 10000
          })
        })
    },
    onSaveFilterProfileDialogConfirm: function () {
      this.saveFilterDialogOpened = false
      this.emitUpdateDataEvent()
      this.loadFilterProfiles()
      this.loadFilter()
    },
    onSaveFilterProfileDialogClose: function () {
      this.saveFilterDialogOpened = false
    },
    updateOrder: function (array) {
      for (let i = 0; i < array.length; i++) {
        array[i].order = i + 1
      }
    },
    cancelDrag: function (evt) {
      if (this.dragEscaped) {
        arrayMove(this.filtersArray, evt.newIndex, evt.oldIndex)
        this.updateOrder(this.filtersArray)
        this.dragEscaped = false
      }
    },
    onDragEnd: function (evt) {
      this.updateOrder(this.filtersArray)
      setTimeout(this.cancelDrag, 100, evt)
    },
    escUpListener: function (e) {
      if (e.code === 'Escape' && !this.escPressed) {
        this.dragEscaped = true
      }
      if (this.escPressed) {
        this.escPressed = false
      }
    },
    escDownListener: function (e) {
      if (e.code == 'Escape') {
        this.escPressed = true
      }
    },
    onMoveUp: function (filter) {
      const index = this.filtersArray.indexOf(filter)
      if (index > 0) {
        arrayMove(this.filtersArray, index, 0)
        this.updateOrder(this.filtersArray)
      }
    },
    emptinessModeSelected: function (filter) {
      return filter.selectedMode && ['empty', 'notEmpty'].includes(filter.selectedMode)
    },
    filterListOptions: function (filterStr, update) {
      update(_, ref => {
        const key = ref.$parent.$vnode.data.key
        const filterOptions = this.filtersArray.find(el => el.key == key).values
        let options = JSON.parse(JSON.stringify(filterOptions))

        if (filterStr !== '') {
          const needle = filterStr.toLowerCase()
          options = options.filter(el => el.name.toLowerCase().indexOf(needle) > -1)
        }

        this.filtersOptions.find(el => el.key == key).values = options
      })
    },
    popupOpened: function (key) {
      if (this.$refs[key] && this.$refs[key][0]) {
        return this.$refs[key][0].hasPopupOpen
      } else {
        return false
      }
    },
    onHidePopup: function (key) {
      if (this.$refs[key] && this.$refs[key][0]) {
        this.$refs[key][0].hidePopup()
      }
    }
  }
}

